import {
    LOCATION_SEARCH_BY_SEARCH_STRING,
    LOCATION_SEARCH_STARTED,
    LOCATION_SEARCH_TEXT_CHANGED,
    LOCATION_SEARCH_ENDED,
    SEARCH_LOCATION_SELECTED,
    SET_LOCATION_SUGGESTION_INDEX,
    CLEAR_LOCATION_SEARCH_SUGGESTIONS
} from '../actions/locationSearchActions';

const initialState = {
    locationSearchIsQuerying: false,
    locationSearchEnabled: false,
    isUserTyping: false,
    selectedLocation: undefined,
    searchText: undefined,
    locationSearchResults: [],
    locationSuggestionIndex: 0
};

export function locationSearch(state = initialState, action) {
    switch (action.type) {
        case LOCATION_SEARCH_BY_SEARCH_STRING.pending: {
            return {
                ...state,
                locationSearchIsQuerying: true
            };
        }
        case LOCATION_SEARCH_BY_SEARCH_STRING.fulfilled: {
            return {
                ...state,
                locationSearchResults: action.payload.slice(0, 6),
                lastError: {},
                locationSearchIsQuerying: false,
                locationSuggestionIndex: 0
            };
        }
        case LOCATION_SEARCH_BY_SEARCH_STRING.rejected: {
            return {
                ...state,
                locationSearchResults: [],
                lastError: action.payload,
                locationSearchIsQuerying: false
            };
        }
        case LOCATION_SEARCH_STARTED: {
            return {
                ...state,
                locationSearchResults: [],
                locationSearchEnabled: true
            };
        }
        case LOCATION_SEARCH_TEXT_CHANGED: {
            return {
                ...state,
                isUserTyping: true,
                searchText: action.payload
            };
        }
        case LOCATION_SEARCH_ENDED: {
            return {
                ...state,
                searchText: state.selectedLocation,
                locationSearchEnabled: false
            };
        }
        case SEARCH_LOCATION_SELECTED: {
            return {
                ...state,
                searchText: action.payload.DisplayCompositeName,
                selectedLocation: action.payload.DisplayCompositeName,
                locationSearchResults: [],
                isUserTyping: false
            };
        }
        case SET_LOCATION_SUGGESTION_INDEX: {
            const { locationSearchResults } = state;
            let locationSuggestionIndex = state.locationSuggestionIndex;

            if (action.payload.increment) {
                locationSuggestionIndex = Math.min(locationSearchResults.length - 1, locationSuggestionIndex + 1);
            } else {
                locationSuggestionIndex = Math.max(0, locationSuggestionIndex - 1);
            }

            return {
                ...state,
                locationSuggestionIndex
            };
        }
        case CLEAR_LOCATION_SEARCH_SUGGESTIONS: {
            return {
                ...state,
                locationSearchResults: initialState.locationSearchResults,
                locationSuggestionIndex: initialState.locationSuggestionIndex
            }
        }
        default: {
            return state;
        }
    }
}
